(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("krypton", [], factory);
	else if(typeof exports === 'object')
		exports["krypton"] = factory();
	else
		root["krypton"] = factory();
})(this, () => {
return 